import { useParams, Navigate, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { AIRPORTS } from "../constants";
import CountryInfo from "./CountryInfo";

function CountryPage() {
  const { countrySlug } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const airport = AIRPORTS.find((a) => a.countrySlug === countrySlug);

  if (!airport) {
    return <Navigate to="/" replace />;
  }

  const pageTitle = t("countryPage.title", {
    country: airport.country,
    defaultValue: `${airport.country} - RenuAirHub`,
  });
  const pageDescription = t("countryPage.description", {
    country: airport.country,
    defaultValue: `Discover ${airport.country} — culture, travel info, and flights at ${airport.name} (${airport.iataCode}).`,
  });

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta
          property="og:url"
          content={`https://renuairhub.com/countries/${countrySlug}`}
        />
        <link
          rel="canonical"
          href={`https://renuairhub.com/countries/${countrySlug}`}
        />
      </Helmet>
      <CountryInfo
        isOpen={true}
        onClose={() => navigate("/")}
        countryCode={airport.iataCode}
      />
    </>
  );
}

export default CountryPage;
